import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import AccountSecurityPanel from '../../components/accountSecurity/AccountSecurityPanel';
import SecurityStyles from '../../components/accountSecurity/SecurityStyles';
import DarkModeToggle from '../../components/common/DarkModeToggle';
import BrandStripes from '../../components/common/BrandStripes';
import { getProfileRoute } from '../../utils/profileRoute';

export default function TwoFactorPage() {
    const { user } = useAuth();
    const { isDark } = useTheme();
    return <div className="account-security security-layout" data-dark={isDark}>
        <SecurityStyles />
        <div style={{ position: 'fixed', right: 20, top: 20, zIndex: 20 }}><DarkModeToggle /></div>
        <aside className="security-brand">
            <Link to="/" aria-label="Co Marca, inicio"><img src={`${process.env.PUBLIC_URL}/logo-comarca-blanco.png?v=2`} alt="Co Marca" /></Link>
            <h1>Un paso más<br />para protegerte.</h1>
            <p>Confirma tu identidad, elige tu método y guarda tus códigos de respaldo.</p>
            <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}><BrandStripes /></div>
        </aside>
        <main className="security-main"><div className="security-card">
            {user ? <AccountSecurityPanel configuration /> : <><h2>Verificación en dos pasos</h2><p>Inicia sesión para configurar la seguridad de tu cuenta.</p><Link to="/login">Iniciar sesión</Link></>}
            {user && <div style={{ marginTop: 28 }}><Link to={getProfileRoute(user)}>Volver a mi perfil</Link></div>}
        </div></main>
    </div>;
}
